// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'babel-polyfill'
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';
import oLocalStorage from '@/services/objectLocalStorage';
import localeService from '@/services/localeService';
import './assets/stylus/main.styl';

Vue.config.productionTip = false;

let messages = {
  'ca-ES': require('./locales/messages_ca-ES.json'),
  'en-GB': require('./locales/messages_en-GB.json'),
  'es-AR': require('./locales/messages_es-AR.json'),
  'es-CL': require('./locales/messages_es-CL.json'),
  'es-CO': require('./locales/messages_es-CO.json'),
  'es-ES': require('./locales/messages_es-ES.json'),
  'es-MX': require('./locales/messages_es-MX.json'),
  'es-UY': require('./locales/messages_es-UY.json'),
  'pt-BR': require('./locales/messages_pt-BR.json')
};

Vue.use(VueI18n);
Vue.use(Vuetify, {
  theme: {
    primary: '#5ea4c8',
    accent: '#da9500'
  }
});

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

let start = () => {
  let defaultLangSelected = oLocalStorage.get('langSelected') !== null ? oLocalStorage.get('langSelected') : process.env.LANGUAGES['en-GB'];

  if (defaultLangSelected === null) {
    defaultLangSelected = process.env.LANGUAGES['en-GB'];
  } else {
    defaultLangSelected = process.env.LANGUAGES[defaultLangSelected.langIso];
  }

  let defaultCountrySelected = oLocalStorage.get('countryConstantsSelected');

  if (defaultCountrySelected === null) {
    localeService.changeCountryLanguage('es');
  }

  const i18n = new VueI18n({
    locale: defaultLangSelected.langIso,
    messages
  });

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    template: '<App/>',
    components: {
      App
    },
    render: h => h(App),
    mounted() {
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event('render-event'))
    }
  });
};

if (oLocalStorage.get('langSelected') === null && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'preproduction')) {
  localeService.getCountryAws(start);
} else {
  start();
}



// WEBPACK FOOTER //
// ./src/main.js